<script setup lang="ts">
import { NEWS_ROUTES, NewsCard, useNewsPreview } from '@features/news'
import { useResponsive } from '@shared/nuxt/useResponsive'

const { isMobile } = useResponsive()
const { news: newsData } = await useNewsPreview()
</script>

<template>
  <div id="newsBlock" class="news-preview">
    <h2 class="news-preview__title">Новости</h2>

    <div class="news-preview__list">
      <div class="news-preview__column">
        <nuxt-link
          v-for="news in newsData?.results.slice(0, 3)"
          :key="news.slug"
          class="news-preview__link"
          :to="NEWS_ROUTES.detail(news.slug)"
        >
          <news-card :news="news" />
        </nuxt-link>
      </div>
      <div class="news-preview__column">
        <div v-if="!isMobile" class="news-preview__column--2">
          <nuxt-link
            v-for="news in newsData?.results.slice(3, 5)"
            :key="news.slug"
            :to="NEWS_ROUTES.detail(news.slug)"
            :title="news.title"
            class="news-preview__link"
          >
            <news-card :news="news" />
          </nuxt-link>
        </div>

        <the-button
          title="Новости"
          :to="NEWS_ROUTES.list"
          variant="secondary"
          block
        >
          Еще новости
        </the-button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.news-preview {
  &__title {
    margin-bottom: 40px;
    font-size: 30px;
    font-weight: 800;
    color: var(--ui-color-supporting-01);

    @include media($bp-tablet) {
      font-size: 40px;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 17px;
    padding-bottom: 80px;

    @include media($bp-tablet) {
      flex-direction: row;
      padding-bottom: 0;
    }

    @include media($bp-desktop-mini) {
      flex-direction: column;
      max-width: 282px;
    }

    @include media($bp-desktop) {
      flex-direction: row;
      max-width: none;
    }
  }

  &__link {
    height: max-content;
    transition: 0.2s ease-in;

    &:hover {
      cursor: pointer;
      transform: translateY(5px);
    }
  }

  &__column,
  &__column--2 {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__column--2 {
    display: flex;

    @include media($bp-desktop-mini) {
      display: none;
    }

    @include media($bp-desktop) {
      display: flex;
    }
  }
}
</style>
